import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/monica.png";
import Imagen2 from "../../../images/modulo12/alumno1.png";
import Imagen3 from "../../../images/modulo12/alumno2.png";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad4.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "equidad" },
    ans2: { value: "", valid: "", correctValue: "machismo" },
    ans3: { value: "", valid: "", correctValue: "oportunidades" },
  });

  const [answersCheck, setAnswersCheck] = useState({
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "1" },
    ans6: { value: "", valid: "", correctValue: "0" },
    ans7: { value: "", valid: "", correctValue: "1" },
  });

  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[4];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[5].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[5].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[3].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[3].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  const handleAnswersCheck = (event, name) => {
    if (answersCheck[name]["value"] === event.target.value) {
      setAnswersCheck({
        ...answersCheck,
        [name]: { ...answersCheck[name], value: "2" },
      });
    } else {
      setAnswersCheck({
        ...answersCheck,
        [name]: { ...answersCheck[name], value: event.target.value },
      });
    }
  };
  const validateAnswersCheck = (event) => {
    event.preventDefault();
    let newAnswers = answersCheck;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answersCheck[key]["correctValue"] === answersCheck[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswersCheck({ ...newAnswers });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Ahora completa el diálogo escribiendo las palabras adecuadas.
          Escógelas del recuadro.
        </li>
      </ul>

      <div className="row align-items-end justify-content-center">
        <div className="col-lg-10 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div className="m-1">Oportunidades</div>
              <div className="m-1">Machismo</div>
              <div className="m-1">Equidad</div>
            </div>
          </Card>
        </div>
        <div className="col-md-4 text-center text-md-start">
          <Card>
            <p className="mb-0">
              Niños, ¿cómo lograremos una situación de{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              entre hombres y mujeres?
            </p>
          </Card>
          <img src={Imagen1} className="img-fluid w-140" alt="Peruanos" />
        </div>
        <div className="col-md-3 text-center text-md-start">
          <Card>
            <p className="mb-0">
              Lo primero que tendríamos que hacer es disminuir el{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />{" "}
            </p>
          </Card>
          <img src={Imagen2} className="img-fluid w-200 mb-4" alt="Peruanos" />
        </div>
        <div className="col-md-3 text-center text-md-start">
          <Card>
            <p className="mb-0">
              Con buena educación garantizamos{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />{" "}
              para todos.
            </p>
          </Card>
          <img src={Imagen3} className="img-fluid w-120 mb-4" alt="Peruanos" />
        </div>
      </div>

      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo12.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <ul className="my-5">
        <li>Lee la lista de palabras</li>
        <li>Marca las palabras que tengan un significado positivo.</li>
      </ul>

      <Card>
        <div className="row">
          <div className="col-md-3 col-6">
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answersCheck.ans4.valid
                }
                type="checkbox"
                value="1"
                checked={answersCheck.ans4.value === "1"}
                onChange={(event) => handleAnswersCheck(event, "ans4")}
              />{" "}
              <span className="ms-2">rechazo</span>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answersCheck.ans5.valid
                }
                type="checkbox"
                value="1"
                checked={answersCheck.ans5.value === "1"}
                onChange={(event) => handleAnswersCheck(event, "ans5")}
              />{" "}
              <span className="ms-2">oportunidades</span>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answersCheck.ans6.valid
                }
                type="checkbox"
                value="1"
                checked={answersCheck.ans6.value === "1"}
                onChange={(event) => handleAnswersCheck(event, "ans6")}
              />{" "}
              <span className="ms-2">obstáculo</span>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answersCheck.ans7.valid
                }
                type="checkbox"
                value="1"
                checked={answersCheck.ans7.value === "1"}
                onChange={(event) => handleAnswersCheck(event, "ans7")}
              />{" "}
              <span className="ms-2">superación</span>
            </div>
          </div>
        </div>
      </Card>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo12.color}`}
          onClick={validateAnswersCheck}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la indicación: Ahora completa el diálogo con las palabras
            adecuadas. Escógelas del recuadro. Explique a los niños y niñas que
            tienen que completar los globos con las palabras “machismo”,
            “oportunidad” y “equidad”. Luego pida al niño o a la niña que lean el
            diálogo en voz alta y revise sus respuestas.
          </li>
          <li>
            Lea la primera indicación: Lee la lista de palabras. Pida a un niño
            o una niña que lea en voz alta las palabras del recuadro. Pregunte
            por el significado de estas palabras. Si alguno de estos
            significados no está claro, explíquelo. Lea la segunda indicación:
            Marca las palabras que tengan un significado positivo. Dé un tiempo para que trabajen individualmente. Revise la
            actividad preguntando por cada una de las palabras. Por ejemplo:
            <ul>
              <li>
                <i>
                  “La primera palabra, “rechazo”, ¿tendrá un significado
                  positivo? (Posible respuesta: No. “Rechazo” significa que algo
                  o alguien no ha sido aceptado o admitido. Por ejemplo: El
                  equipo de básquetbol no aceptó a la nueva estudiante. El
                  rechazo se produjo debido a su baja estatura). La segunda
                  palabra, “oportunidades”, ¿tendrá un significado positivo?
                  (Posible respuesta: Sí. Las oportunidades se refieren a las
                  posibilidades que se le presentan a una persona para alcanzar
                  una mejora. Por ejemplo: Sus buenas notas en la universidad,
                  le brindaron estupendas oportunidades laborales). La tercera
                  palabra, “obstáculo”, ¿tendrá un significado positivo?
                  (Posible respuesta: No. La palabra obstáculo se refiere a las
                  dificultades, los impedimentos o las trabas para lograr algo.
                  Ejemplo: Debido a sus frecuentes inasistencias, se le
                  presentaron muchos obstáculos para aprobar los cursos en su
                  escuela). La cuarta palabra, “superación”, ¿tendrá un
                  significado positivo? (Posible respuesta: Sí. La palabra
                  superación significa vencer obstáculos o dificultades.
                  Ejemplo: La superación de la atleta tras su larga enfermedad
                  fue impresionante).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
